import { getBackHost } from '../constants';

export const getHomeUrl = () => {
  return getBackHost();
}
